exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-modal .modal-dialog{max-width:800px}.error-modal .card-header{background:#9e9fa5;color:#fff;padding:4px 8px;display:flex}.error-modal .card-header>svg{margin-right:5px;transition:all 0.3s ease-in-out;transform:rotate(90deg)}.error-modal .card-header.collapsed>svg{transform:rotate(0deg)}.error-modal .accordion .card:only-child{border-bottom:1px solid #ddd;border-radius:3px}.error-modal .error-details{margin-bottom:1em}.error-modal .btn-primary{background:#575860;border-color:#575860}\n", ""]);

// exports
